import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {Box, Button, CircularProgress, Container, TextField, Typography} from "@mui/material";
import {requestEmailOtp} from "../api/api";

const ForgotPasswordPage = () => {
    const {t} = useTranslation();

    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (loading) return;

        setError("");
        setMessage("");
        setLoading(true);

        try {
            await requestEmailOtp(email);

            setMessage(t("forgotpassword.messages.codeSent"));

            setTimeout(() => {
                navigate("/verify-otp", {state: {email}});
            }, 1200);
        } catch (err: any) {
            setError(err.message ?? t("forgotpassword.errors.default"));
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="xs">
            <Box py={8}>
                <Box p={3} boxShadow={3} borderRadius={2}>
                    <Typography variant="h5" align="center" gutterBottom>
                        {t("forgotpassword.title")}
                    </Typography>

                    <Typography variant="body2" align="center" mb={2}>
                        {t("forgotpassword.subtitle")}
                    </Typography>

                    {error && (
                        <Typography color="error" align="center">
                            {error}
                        </Typography>
                    )}

                    {message && (
                        <Typography color="primary" align="center">
                            {message}
                        </Typography>
                    )}

                    <form onSubmit={handleSubmit}>
                        <TextField
                            fullWidth
                            label={t("forgotpassword.email")}
                            type="email"
                            required
                            margin="normal"
                            value={email}
                            disabled={loading}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            disabled={loading}
                            sx={{mt: 2}}
                            startIcon={loading ? <CircularProgress size={18} color="inherit"/> : undefined}
                        >
                            {loading ? t("forgotpassword.sending") : t("forgotpassword.sendOtp")}
                        </Button>
                    </form>
                </Box>
            </Box>
        </Container>
    );
};

export default ForgotPasswordPage;